import Axios from 'axios';
import { AuthActionType } from '../actions/actionTypes';

const authState = {
    isLoggedIn: false,
    user: {
        userid: '',
        name: '',
        expires_at: '',
        accessToken: '',
        refreshToken: '',
        authorities: [],
        role_name: '',
        email: '',
        login_type: '',
    },
    log: [],
    errorMsg: '',
    authStatusSuccessful: ''
}

//NOT FOR PYTHON LOGIN YET
const getAuthState = () => {
    
    //return authState //TESTING PURPOSES

    try {
        const auth = localStorage.getItem("auth");

        const authobj = JSON.parse(auth);
        const { expires_at, accessToken } = authobj.user

        // console.log('AuthReducer getAuthState authobj: ' + JSON.stringify(authobj));
        if (new Date(expires_at) > new Date()){

            Axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            return authobj;
        }
        return authState;
    } catch (error) {
        console.log('AuthReducer getAuthState error: ' + JSON.stringify(error));
        return authState
    }
}

const newAuth = getAuthState();

const authReducer = (state = newAuth, action) => {

    switch(action.type){

        //UNNEEDED
        // case AuthActionType.FETCH_LOGIN:
        //     console.log("AuthReducer authReducer AuthActionType.FETCH_LOGIN action.payload: ");
        //     console.log(action.payload);
        //     return { log: action.payload }
        
        case AuthActionType.LOGOUT_FAIL:
            return state;
        
        case AuthActionType.LOGIN_FAIL:
            return state;

        case AuthActionType.LOGOUT_SUCCESS:
            localStorage.removeItem("auth");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");  

            return authState;
        
        case AuthActionType.LOGIN_SUCCESS:
            const loginAuthState = {
                isLoggedIn: true,
                user: action.payload,
            };
                
            //TODO: Does not work with python login method
            Axios.defaults.headers.common['Authorization'] = `Bearer ${action.payload.accessToken}`;

            localStorage.setItem("auth", JSON.stringify(loginAuthState));

            console.log('AuthReducer user:' + JSON.stringify(action.payload))
            return {                
                isLoggedIn: true,
                user: action.payload,
                ...state,
            }
        case AuthActionType.REGISTER_SUCCESS:
            return {
                authStatusSuccessful: action.payload['STATUS_SUCCESS'],
                user: {email:action.payload['EMAIL']}
            }
        default:
            return state;
    }
}

export default authReducer;
